<template>
  <a-card>
    <div class="text-right red-font">* 标红指标为参与评价指标</div>
    <table-view
      :data="tableData"
      :columns="tableColumns"
      :pagination="false"
      :scroll="{ x: 600 }"
      :showSizeChanger="false"
      :showQuickJumper="false"
      rowKey="key"
      :loading="loading"
      v-if="this.cardType == 1"
    >
      <template v-slot:assetRatio="{ tableRow }">
        <span :class="[tableRow.flag === 1 ? 'red-font' : '']">
          <span v-if="tableRow.filter == 'formatAmount'">
            {{ tableRow.assetRatio | formatAmount }}
          </span>
          <span v-else-if="tableRow.filter == 'confirmStatus'">
            {{ CONFIRM_STATUS_OBJ[tableRow.assetRatio] || '' }}
          </span>
          <span v-else-if="tableRow.filter == 'companyProperty'">
            {{ COMPANY_PROPERTY_OBJ[tableRow.assetRatio] }}
          </span>
          <span v-else>{{ tableRow.assetRatio }}</span>
        </span>
      </template>
    </table-view>

    <table-view
      :data="this.scoreData"
      :columns="tableColumnsCard"
      :pagination="false"
      :scroll="{ x: 600 }"
      :loading="loading"
      v-if="this.cardType == 2"
    ></table-view>

    <table-view
      :data="this.originalCardData"
      :columns="tableColumnsCard"
      :pagination="false"
      :scroll="{ x: 600 }"
      :loading="loading"
      v-if="this.cardType == 3"
    ></table-view>
  </a-card>
</template>

<script>
import { TableView } from 'lxfintech-fe'
import {
  SCORE_TABLE_OBJ,
  CONFIRM_STATUS_OBJ,
  COMPANY_PROPERTY_OBJ,
} from './const'

export default {
  name: 'ScoreTable',
  data() {
    return {
      CONFIRM_STATUS_OBJ,
      COMPANY_PROPERTY_OBJ,
      tableColumns: [
        {
          title: '变量',
          width: 250,
          dataIndex: 'label',
        },
        {
          title: '财务指标',
          width: 100,
          dataIndex: 'financialRatio',
        },
        {
          title: '指标录入（单位限制）',
          width: 150,
          scopedSlots: { customRender: 'assetRatio' },
        },
        {
          title: '指标得分',
          width: 100,
          dataIndex: 'score',
        },
      ],
      //自定义评分卡类型
      tableColumnsCard: [
        {
          title: '变量',
          width: 250,
          dataIndex: 'targetName',
        },
        {
          title: '财务指标',
          width: 100,
          dataIndex: 'targetTypeStr',
        },
        {
          title: '指标录入（单位限制）',
          width: 150,
          dataIndex: 'targetScoreStr',
        },
        {
          title: '指标得分',
          width: 100,
          dataIndex: 'countScore',
        },
      ],
    }
  },
  props: [
    'loading',
    'flag',
    'originalData',
    'scoreData',
    'originalCardData',
    'cardType',
  ],
  computed: {
    tableData() {
      const flag = this.flag
      const originalData = this.originalData
      const scoreData = this.scoreData
      const list = Object.keys(SCORE_TABLE_OBJ).map(key => {
        return {
          flag: (flag && flag[key]) || '',
          label: SCORE_TABLE_OBJ[key].label,
          financialRatio: SCORE_TABLE_OBJ[key].financialRatio,
          filter: SCORE_TABLE_OBJ[key].filter,
          assetRatio: originalData && originalData[key],
          score: scoreData && scoreData[key],
          key,
        }
      })
      return [
        ...list,
        {
          label: '汇总得分',
          score: (scoreData && scoreData.totalScore) || '',
          key: 'totalScore',
        },
        {
          label: '人工调整',
          score: (scoreData && scoreData.manualLevel) || '',
          key: 'manualLevel',
        },
      ]
    },
    //自定义评分卡类型
    // tableDataCard() {
    //   debugger
    //   // const flag = this.flag
    //   // const originalData = this.originalData
    //   this.tableDataCard = this.scoreData
    //   // const list = Object.keys(SCORE_TABLE_OBJ).map(key => {
    //   //   return {
    //   //     flag: (flag && flag[key]) || '',
    //   //     label: '',
    //   //     financialRatio: SCORE_TABLE_OBJ[key].financialRatio,
    //   //     filter: SCORE_TABLE_OBJ[key].filter,
    //   //     assetRatio: originalData && originalData[key],
    //   //     score: scoreData && scoreData[key],
    //   //     key,
    //   //   }
    //   // })
    //   // return [
    //   //   ...list,
    //   //   {
    //   //     label: '汇总得分',
    //   //     score: (scoreData && scoreData.totalScore) || '',
    //   //     key: 'totalScore',
    //   //   },
    //   //   {
    //   //     label: '人工调整',
    //   //     score: (scoreData && scoreData.manualLevel) || '',
    //   //     key: 'manualLevel',
    //   //   },
    //   // ]
    // },
  },
  components: {
    TableView,
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-card-body {
  .text-right {
    color: red;
    margin-bottom: 10px;
    font-size: 12px;
  }
  .red-font {
    color: red;
    font-weight: bold;
  }
}
</style>
